import { useState, useEffect } from "react";
import BackBtn from "../shared/backBtn/BackBtn";
import { useTranslation } from "react-i18next";
import QuotationHeader from "./components/QuotationHeader/QuotationHeader";
import HospitalOffers from "./components/HospitalOffers/HospitalOffers";
import QuotationSummary from "./components/QuotationSummary/QuotationSummary";
import "./style.css";
import { useParams } from "react-router-dom";
import QuotationProcessSkeleton from "./components/skeleton/QuotationProcessSkeleton";
import { GetAMDetails, GetAMOrderQuotationDetials } from "@/api/endpoints/AccountManager";
import { useGet } from "@/api/hooks";

const QuotationProcess = () => {
  const { t } = useTranslation();
  const {id, medicalOrderId} = useParams();

  
  const { result: quotationData, isPending } = useGet({
      endPoint: GetAMOrderQuotationDetials,
      depArr: [medicalOrderId],
      allowFetch: !!medicalOrderId,
      params: [medicalOrderId]
  });
  const { result: patientData, isPending: patientPending } = useGet({
      endPoint: GetAMDetails,
      depArr: [id],
      allowFetch: !!id,
      params: [id]
  });
  

  const [selectedHospital, setSelectedHospital] = useState(null);
 

  if(patientPending || isPending) return <QuotationProcessSkeleton />

  return (
    <div className="d-flex flex-column gap-3 mx-md-5 mx-2 qp-page">
      <BackBtn title={t("back-to-pipeline")} />
      <div className="qp-layout">
        <div className="qp-main">
          <QuotationHeader quotationData={quotationData} patientData={patientData} />
          <HospitalOffers
            hospitals={quotationData?.availableProviders}
            onSelectHospital={setSelectedHospital}
            selectedHospital={selectedHospital}
          />    
        </div>
        <QuotationSummary selectedHospital={selectedHospital} quotationData={quotationData} />
      </div>
    </div>
  );
};

export default QuotationProcess;
